export enum enmPdfExportType {
    PDF = 1,
    PRINT = 2
}